import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Controller from "./Controller";

const App = () => {
  return (
    <Router>
      <div className="main-container">
        <Controller />
      </div>
    </Router>
  );
};

export default App;
